export const isRefundPending = payment =>
  payment?.refundProcessorStatus === 'Pending' && !payment?.hasRefund

const canManageClearedPayment = (payment, canManagePaymentStatuses) =>
  Boolean(
    canManagePaymentStatuses &&
      payment?.processorStatus === 'Success' &&
      !payment?.hasChargeback &&
      !payment?.hasRefund &&
      !isRefundPending(payment)
  )

export const canRecordRefund = (payment, canManagePaymentStatuses) =>
  canManageClearedPayment(payment, canManagePaymentStatuses) &&
  payment?.paymentProcessedBy === 'Nuvei'

export const canDoRefund = (payment, canManagePaymentStatuses) =>
  canManageClearedPayment(payment, canManagePaymentStatuses) &&
  payment?.paymentProcessedBy === 'Nuvei'

export const canAddChargeback = (payment, canManagePaymentStatuses) =>
  canManageClearedPayment(payment, canManagePaymentStatuses)
